export const GET_ALLVIDEOGAMES = 'GET_ALLVIDEOGAMES';
export const GET_GAMESBYNAME = 'GET_GAMESBYNAME';
export const GET_VIDEOGAMEDETAILS = 'GET_VIDEOGAMEDETAILS';
export const CREATE_VIDEOGAME = 'CREATE_VIDEOGAME';
export const GET_GENRES = 'GET_GENRES';
export const GET_PLATFORMS = 'GET_PLATFORMS';
export const FILTER_GAMES = 'FILTER_GAMES';
